import React from 'react'
import { alpha } from '@mui/material/styles'
import PropTypes from 'prop-types'
import { Button, Box } from '@mui/material'
import AndroidIcon from '@mui/icons-material/Android'
import AppleIcon from '@mui/icons-material/Apple'
import { Preview } from './common/style'
import Teaser from './common/Teaser'
import Screenshots from './common/Screenshots'
import Reviews from './common/Reviews'
import Summary from './common/Summary'
import Contribution from './common/Contribution'
import { ProjectDialogContent } from '.'

export default function ProjectPlity({ color, screenshots, reviews, summary, contribution }) {
  return (
    <ProjectDialogContent>
      <Preview
        style={{ width: '60%' }}
        alt='plity'
        src='/static/works/plity/plity1.png'
      />
      <Preview
        style={{ width: '40%' }}
        alt='plity'
        src='/static/works/plity/plity2.jpg'
      />
      <Box
        sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center', mb: 10 }}
      >
        <Button
          size='large'
          variant='contained'
          startIcon={<AndroidIcon />}
          disabled
          sx={{ '&.Mui-disabled': { color, backgroundColor: alpha(color, 0.12), border: `1px solid ${alpha(color, 0.25)}` }, textTransform: 'none' }}
        >
          {'Android (currently unavailable)'}
        </Button>
        <Button
          size='large'
          variant='contained'
          startIcon={<AppleIcon />}
          disabled
          sx={{ '&.Mui-disabled': { color, backgroundColor: alpha(color, 0.12), border: `1px solid ${alpha(color, 0.25)}` }, textTransform: 'none' }}
        >
          {'iOS (currently unavailable)'}
        </Button>
      </Box>
      <Summary color={color} summary={summary} />
      <Contribution color={color} contribution={contribution} />
      <Teaser color={color} videoId='QejBzv7bAhw' />
      <Screenshots color={color} screenshots={screenshots} alt='plity' />
      <Reviews color={color} reviews={reviews} alt='plity' />
    </ProjectDialogContent>
  )
}

Teaser.propTypes = {
  color: PropTypes.string,
}
ProjectPlity.propTypes = {
  color: PropTypes.string,
  screenshots: PropTypes.array,
  reviews: PropTypes.array,
  summary: PropTypes.object,
  contribution: PropTypes.array
}
